import { render, staticRenderFns } from "./aduaneroInformacionGeneralExp.vue?vue&type=template&id=7ccecf70"
import script from "./aduaneroInformacionGeneralExp.vue?vue&type=script&lang=js"
export * from "./aduaneroInformacionGeneralExp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports